var _path, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnQ19(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1",
    "data-name": 1,
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.161,
    height: 59.738,
    viewBox: "0 0 46.161 59.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M42.112,59.738V56.464h2.43v3.273Zm-39.683,0V56.464h2.43v3.273ZM1.2,56.464a1.2,1.2,0,0,1-1.2-1.2V1.2A1.2,1.2,0,0,1,1.2,0H44.961a1.2,1.2,0,0,1,1.2,1.2V55.264a1.2,1.2,0,0,1-1.2,1.2Z",
    fill: "#e1f4fb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 36.657,
    height: 37.336,
    rx: 1.2,
    transform: "translate(5.431 8.825)",
    fill: "#fff",
    stroke: "#00a3da",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flame",
    transform: "translate(13.586 18.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M4.177,25.164A19.524,19.524,0,0,1,.83,20.431a10.73,10.73,0,0,1-.635-6.175A13.319,13.319,0,0,1,2.85,8.542a5.5,5.5,0,0,0,1.385,4.04A9.6,9.6,0,0,1,6.428,4.617,16.5,16.5,0,0,1,13.469,0a5.689,5.689,0,0,0-.981,5.425,22.621,22.621,0,0,0,2.6,5.137,11.464,11.464,0,0,1,1.962,5.31,18.562,18.562,0,0,0,1.443-3.059,6.044,6.044,0,0,0,.231-3.347,8.584,8.584,0,0,1,1.9,4.155,17.466,17.466,0,0,1,.058,4.906,12.269,12.269,0,0,1-1.674,5.137,9.638,9.638,0,0,1-5.021,3.751C10.41,28.049,6.89,27.53,4.177,25.164Z",
    transform: "translate(0)",
    fill: "#f3705a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M3.813,15.641c4.733,1.847,9.408-3.751,6.81-8.08,0-.058-.058-.058-.058-.115.231,2.366-.346,4.1-1.443,5.079A5.391,5.391,0,0,0,8.6,8.138C7.911,6.81,6.93,5.6,6.179,4.329A6.135,6.135,0,0,1,5.2,0a7.611,7.611,0,0,0-2.77,4.271A7.726,7.726,0,0,0,3.005,9.35,3.793,3.793,0,0,1,1.447,6.58,5.943,5.943,0,0,0,0,10.562,5.879,5.879,0,0,0,3.813,15.641Z",
    transform: "translate(4.75 11.658)",
    fill: "#ffd15c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnQ19);
export default __webpack_public_path__ + "static/media/on_Q1_9_.2d455c88f203feac3a73ede779b27fb5.svg";
export { ForwardRef as ReactComponent };